"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buttonThemes = exports.buttonSizes = exports.Loader = exports.IconWrapper = exports.HBBUTTON_BORDER_RADIUS = exports.CustomButton = exports.Button = void 0;
exports.getButtonBorderRadius = getButtonBorderRadius;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _styledIs = _interopRequireWildcard(require("styled-is"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _color = require("../../utils/color.utils");
var _mixins = require("../../styles/mixins");
var _fonts = require("../../styles/fonts");
var _spacing = _interopRequireDefault(require("../../styles/spacing"));
var _animations = require("../../styles/animations");
var _variables = require("../../styles/variables");
var _HBLoader = _interopRequireDefault(require("../HBLoader/HBLoader"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* Drop shadow */
var elevation = {
  '0': '0 2px 5px 0 rgba(0, 18, 71, 0.2)',
  '1': {
    "default": '0 1px 3px 0 rgba(0, 18, 71, 0.2)',
    hover: '0 1px 3px 0 rgba(0, 18, 71, 0.4)'
  },
  none: 'none'
};

/* Disabled state opacity */
var disabledBgOpacity = {
  '0': 15,
  '1': 25
};
var iconSpacing = {
  xs: _spacing["default"][4],
  sm: _spacing["default"][8],
  md: _spacing["default"][8],
  lg: _spacing["default"][8]
};

/* Button sizes */
var buttonSizes = exports.buttonSizes = {
  system: {
    xs: {
      fontSize: '14px',
      lineHeight: '1',
      height: '30px',
      padding: '1px 8px 0px'
    },
    sm: {
      fontSize: '14px',
      lineHeight: '1',
      padding: '1px 16px 0px',
      height: '36px'
    },
    md: {
      fontSize: '16px',
      lineHeight: '1',
      height: '42px',
      padding: '1px 20px 0'
    },
    lg: {
      fontSize: '18px',
      lineHeight: '1',
      height: '48px',
      padding: '1px 24px 0px'
    }
  },
  builder: {
    sm: {
      fontSize: '16px',
      padding: '0 14px',
      height: '40px'
    },
    md: {
      fontSize: '18px',
      padding: '0 14px',
      height: '42px'
    },
    xl: {
      fontSize: '18px',
      padding: '0 14px',
      height: '48px'
    }
  }
};
var HBBUTTON_BORDER_RADIUS = exports.HBBUTTON_BORDER_RADIUS = '2px';

/* Button themes */

var primaryStyles = {
  color: _colors["default"].white,
  fontWeight: 700,
  hoverColor: _colors["default"].white,
  boxShadow: elevation[0],
  splitterBackground: _colors["default"].neutral800,
  hoverBoxShadow: elevation[0],
  disabledBgOpacity: disabledBgOpacity[1]
};
var baseSecondaryStyles = {
  fontWeight: 600,
  disabledBgOpacity: disabledBgOpacity[1]
};
var secondarySolidStyles = _objectSpread(_objectSpread({}, baseSecondaryStyles), {}, {
  background: _colors["default"].white,
  hoverBackground: _colors["default"].white,
  openMenuButtonColor: _colors["default"].neutral100,
  splitterBackground: _colors["default"].neutral200,
  boxShadow: elevation[1]["default"],
  hoverBoxShadow: elevation[1].hover
});
var secondaryInvisibleStyles = _objectSpread(_objectSpread({}, baseSecondaryStyles), {}, {
  background: _colors["default"].transparent,
  boxShadow: elevation.none,
  hoverBoxShadow: elevation.none,
  disabledBgOpacity: disabledBgOpacity[0]
});
var secondaryStyles = {
  color: _colors["default"].white,
  fontWeight: 700,
  hoverColor: _colors["default"].white,
  boxShadow: elevation[0],
  hoverBoxShadow: elevation[0],
  disabledBgOpacity: disabledBgOpacity[1]
};
var buttonThemes = exports.buttonThemes = {
  primary: _objectSpread({
    background: _colors["default"].neutral900,
    hoverBackground: _colors["default"].black,
    splitterBackground: (0, _color.opacityHex)(_colors["default"].black, 70),
    splitterHoverBackground: _colors["default"].black
  }, primaryStyles),
  'primary-blue': _objectSpread({
    background: _colors["default"].blue20,
    hoverBackground: _colors["default"].blue25,
    splitterBackground: (0, _color.opacityHex)(_colors["default"].blue25, 70),
    splitterHoverBackground: _colors["default"].blue25
  }, primaryStyles),
  'primary-alternative': _objectSpread({
    background: _colors["default"].blue20,
    hoverBackground: _colors["default"].blue25,
    splitterBackground: (0, _color.opacityHex)(_colors["default"].blue25, 70),
    splitterHoverBackground: _colors["default"].blue25
  }, primaryStyles),
  'primary-alpine': _objectSpread({
    background: _colors["default"].alpine,
    hoverBackground: _colors["default"].alpineDark
  }, primaryStyles),
  'secondary-ai': _objectSpread(_objectSpread({}, secondarySolidStyles), {}, {
    color: _colors["default"].neutral900,
    hoverColor: _colors["default"].black,
    disabledColor: (0, _color.opacityHex)(_colors["default"].neutral900, 25),
    disabledBoxShadow: elevation[1]["default"],
    background: _mixins.aiButtonGradient,
    hoverBackground: _mixins.aiButtonGradient
  }),
  'secondary-solid-primary': _objectSpread({
    color: _colors["default"].neutral900,
    hoverColor: _colors["default"].black,
    disabledColor: (0, _color.opacityHex)(_colors["default"].neutral900, 25),
    disabledBoxShadow: elevation[1]["default"]
  }, secondarySolidStyles),
  'secondary-solid-secondary': _objectSpread({
    color: _colors["default"].neutral800,
    hoverColor: _colors["default"].neutral900,
    disabledColor: _colors["default"].neutral600
  }, secondarySolidStyles),
  'secondary-solid-primary-alternative': _objectSpread({
    color: _colors["default"].blue20,
    hoverColor: _colors["default"].blue25,
    disabledColor: _colors["default"].blue20_50
  }, secondarySolidStyles),
  'secondary-invisible-alternative': _objectSpread({
    color: _colors["default"].blue20,
    hoverColor: _colors["default"].blue25,
    disabledColor: _colors["default"].blue20_50
  }, secondaryInvisibleStyles),
  'secondary-solid-destructive': _objectSpread({
    color: _colors["default"].red500,
    hoverColor: _colors["default"].red600,
    disabledColor: (0, _color.opacityHex)(_colors["default"].red500, 25),
    disabledBoxShadow: elevation[1]["default"]
  }, secondarySolidStyles),
  'secondary-invisible-primary': _objectSpread({
    color: _colors["default"].neutral900,
    hoverColor: _colors["default"].neutral900,
    hoverBackground: (0, _color.opacityHex)(_colors["default"].neutral900, 8),
    // TODO: correct color?
    disabledColor: (0, _color.opacityHex)(_colors["default"].neutral900, 8)
  }, secondaryInvisibleStyles),
  'secondary-invisible-secondary': _objectSpread({
    color: _colors["default"].neutral800,
    // TODO: correct color?
    disabledColor: (0, _color.opacityHex)(_colors["default"].neutral600, 5),
    hoverColor: _colors["default"].neutral900,
    hoverBackground: _colors["default"].neutral200
  }, secondaryInvisibleStyles),
  'secondary-invisible-destructive': _objectSpread({
    color: _colors["default"].red50,
    disabledColor: _colors["default"].red50_35,
    hoverColor: _colors["default"].red50,
    hoverBackground: _colors["default"].red50_08
  }, secondaryInvisibleStyles),
  'secondary-destructive': _objectSpread({
    background: _colors["default"].red500,
    hoverBackground: _colors["default"].red600,
    splitterBackground: (0, _color.opacityHex)(_colors["default"].red600, 70),
    splitterHoverBackground: _colors["default"].red600
  }, secondaryStyles),
  'secondary-translucent': _objectSpread({
    background: _colors["default"].black_07,
    hoverBackground: _colors["default"].black_08,
    splitterBackground: _colors["default"].black_05,
    splitterHoverBackground: _colors["default"].black_08,
    disabledColor: _colors["default"].white_04
  }, secondaryStyles),
  'secondary-translucent-secondary': _objectSpread({
    background: _colors["default"].transparent,
    hoverBackground: _colors["default"].white_02,
    splitterBackground: (0, _color.opacityHex)(_colors["default"].black, 70),
    splitterHoverBackground: _colors["default"].black
  }, secondaryInvisibleStyles),
  'secondary-alpine': _objectSpread({
    background: _colors["default"].alpine,
    hoverBackground: _colors["default"].alpineDark
  }, secondaryStyles),
  'button-link': _objectSpread({
    color: _colors["default"].neutral800,
    hoverColor: _colors["default"].neutral900,
    hoverBackground: _colors["default"].transparent,
    disabledColor: (0, _color.opacityHex)(_colors["default"].neutral600, 5)
  }, secondaryInvisibleStyles),
  'button-link-solid': _objectSpread({
    color: _colors["default"].textPrimary,
    hoverColor: _colors["default"].textPrimary,
    hoverBackground: _colors["default"].transparent,
    disabledColor: (0, _color.opacityHex)(_colors["default"].neutral600, 5)
  }, secondaryInvisibleStyles),
  'button-link-secondary': _objectSpread({
    hoverBackground: _colors["default"].transparent,
    disabledColor: (0, _color.opacityHex)(_colors["default"].neutral600, 5)
  }, secondaryInvisibleStyles),
  'button-link-blue': _objectSpread({
    color: _colors["default"].blue20,
    hoverColor: _colors["default"].blue25,
    hoverBackground: _colors["default"].transparent,
    disabledColor: _colors["default"].blue20_50
  }, secondaryInvisibleStyles),
  'button-link-alpine': _objectSpread({
    color: _colors["default"].alpine,
    hoverColor: _colors["default"].alpineDark,
    hoverBackground: _colors["default"].transparent,
    disabledColor: _colors["default"].alpine_01
  }, secondaryInvisibleStyles),
  'link-button-accent': _objectSpread({
    color: _colors["default"].white,
    hoverColor: _colors["default"].white_085,
    hoverBackground: _colors["default"].transparent,
    disabledColor: _colors["default"].blue20_50,
    textTransform: 'capitalize'
  }, secondaryInvisibleStyles),
  'link-button-neutral': _objectSpread({
    color: _colors["default"].neutral900,
    hoverColor: _colors["default"].neutral900,
    hoverBackground: _colors["default"].transparent,
    disabledColor: _colors["default"].neutral400
  }, secondaryInvisibleStyles),
  custom: {
    disabledBgOpacity: disabledBgOpacity[1]
  }
};

// DON'T USE THESE THEMES UNTIL THIS AB-TEST IS COMPLETE!
// https://console.statsig.com/5XY7V8GlxGy1kEv0oEI7pk/experiments/smarf_share_button_color/setup
// I wrote it this way to intentionally hide these keys from the TS compiler 🥷
buttonThemes['primary-purple'] = _objectSpread(_objectSpread({}, primaryStyles), {}, {
  background: _colors["default"].purple500,
  hoverBackground: _colors["default"].purple600,
  disabledBgOpacity: disabledBgOpacity[0],
  splitterBackground: (0, _color.opacityHex)(_colors["default"].purple600, 70),
  splitterHoverBackground: _colors["default"].purple600
});
var newStyles = {
  fontWeight: 600,
  borderRadius: '4px',
  textTransform: 'capitalize'
};
buttonThemes['primary-purple-new'] = _objectSpread(_objectSpread({}, newStyles), {}, {
  color: _colors["default"].white,
  hoverColor: _colors["default"].white,
  background: _colors["default"].purple500,
  hoverBackground: _colors["default"].purple600,
  disabledBgOpacity: disabledBgOpacity[0],
  splitterBackground: _colors["default"].purple700,
  splitterHoverBackground: _colors["default"].purple600
});
buttonThemes['secondary-neutral-new'] = _objectSpread(_objectSpread({}, newStyles), {}, {
  color: _colors["default"].textPrimary,
  hoverColor: _colors["default"].textPrimary,
  hoverBackground: _colors["default"].neutral200,
  disabledBgOpacity: disabledBgOpacity[0],
  background: _colors["default"].white,
  disabledColor: _colors["default"].textDisabled,
  borderColor: _colors["default"].textPrimary,
  disabledBorderColor: _colors["default"].textDisabled,
  splitterBackground: _colors["default"].textTertiary
});
function getButtonBorderRadius(borderRadius, buttonSize) {
  var scope = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'system';
  var percentBorderRadius = borderRadius / 100;
  return percentBorderRadius * (Number(buttonSizes[scope][buttonSize].height.replace('px', '')) / 2);
}
function getIconFillStyle(isHover, shouldUseIconDefaultFill) {
  return shouldUseIconDefaultFill ? null : (0, _styledComponents.css)(["i svg *{fill:currentColor;", ";}"], isHover ? '' : _animations.transition.apply(void 0, ['fill'].concat((0, _toConsumableArray2["default"])(_variables.hoverEase))));
}
function getBorderFromTheme(theme) {
  var _ref = buttonThemes[theme] || {},
    borderColor = _ref.borderColor,
    borderRadius = _ref.borderRadius,
    disabledBorderColor = _ref.disabledBorderColor;
  return (0, _styledComponents.css)(["", " ", ""], borderColor && (0, _styledComponents.css)(["border:1px solid ", ";&:disabled,&:disabled:hover{border:1px solid ", ";}"], borderColor, disabledBorderColor), borderRadius && (0, _styledComponents.css)(["border-radius:", ";"], borderRadius));
}
function getButtonTheme(theme, shouldUseIconDefaultFill) {
  if (!buttonThemes[theme]) {
    return null;
  }
  var _buttonThemes$theme = buttonThemes[theme],
    color = _buttonThemes$theme.color,
    fontWeight = _buttonThemes$theme.fontWeight,
    hoverColor = _buttonThemes$theme.hoverColor,
    background = _buttonThemes$theme.background,
    hoverBackground = _buttonThemes$theme.hoverBackground,
    boxShadow = _buttonThemes$theme.boxShadow,
    hoverBoxShadow = _buttonThemes$theme.hoverBoxShadow,
    textTransform = _buttonThemes$theme.textTransform;
  function getButtonHoverState() {
    return (0, _styledComponents.css)(["color:", ";background:", " !important;box-shadow:", ";", " ", ";"], hoverColor, hoverBackground, hoverBoxShadow, getBorderFromTheme(theme), getIconFillStyle(true, shouldUseIconDefaultFill));
  }
  return (0, _styledComponents.css)(["&,&:focus{", ";font-weight:", ";background:", " !important;color:", ";box-shadow:", ";", " ", ";}&:hover{", "}&:focus-visible{", "}", ";"], _mixins.proximaNova, fontWeight, background, color, boxShadow, getBorderFromTheme(theme), getIconFillStyle(false, shouldUseIconDefaultFill), getButtonHoverState(), getButtonHoverState(), textTransform && getTextTransform(textTransform));
}
function getDisabledStyles(theme, customTheme) {
  var _buttonThemes$theme2 = buttonThemes[theme],
    _disabledBgOpacity = _buttonThemes$theme2.disabledBgOpacity,
    disabledColor = _buttonThemes$theme2.disabledColor,
    disabledBoxShadow = _buttonThemes$theme2.disabledBoxShadow,
    background = _buttonThemes$theme2.background;
  function getBackground() {
    var calculatedBackground = theme === 'custom' ? customTheme.background : background;
    if (calculatedBackground === _colors["default"].transparent) {
      return background;
    }
    return calculatedBackground;
  }
  function calculateBackground() {
    var calculatedBackground = getBackground();
    if (calculatedBackground === _colors["default"].transparent || !calculatedBackground) {
      return calculatedBackground;
    }
    return (0, _color.opacityHex)(calculatedBackground, _disabledBgOpacity);
  }
  var color = theme === 'custom' ? customTheme.color : disabledColor;
  var calculatedBackground = calculateBackground();

  /*
      This function is a bit of a mess.. There are 3 parameters that set the disabled styles:
      disabledColor - this is used for buttons with an invisible theme (ie - no background color). When disabled, the text changes color.
      background color - unless transparent/white, we add an opacity to the background color.
  */
  return (0, _styledComponents.css)(["&:disabled,&:disabled:hover{border:none;", " ", " box-shadow:", " !important;", "}"], getBorderFromTheme(theme), color && "color: ".concat(color, " !important;"), disabledBoxShadow || 'none', calculatedBackground && "background: ".concat(calculatedBackground, " !important;"));
}
function getCustomTheme(customTheme) {
  var _customFont$fontFamil;
  var _customTheme$color = customTheme.color,
    color = _customTheme$color === void 0 ? _colors["default"].white : _customTheme$color,
    _customTheme$backgrou = customTheme.background,
    background = _customTheme$backgrou === void 0 ? _colors["default"].neutral900 : _customTheme$backgrou,
    _customTheme$fontFami = customTheme.fontFamily,
    fontFamily = _customTheme$fontFami === void 0 ? 'ProximaNova' : _customTheme$fontFami,
    _customTheme$fontStyl = customTheme.fontStyle,
    fontStyle = _customTheme$fontStyl === void 0 ? 'normal' : _customTheme$fontStyl,
    _customTheme$fontWeig = customTheme.fontWeight,
    fontWeight = _customTheme$fontWeig === void 0 ? 600 : _customTheme$fontWeig,
    fontSize = customTheme.fontSize,
    border = customTheme.border,
    borderRadius = customTheme.borderRadius,
    hoverBackgroundColor = customTheme.hoverBackgroundColor,
    hoverColor = customTheme.hoverColor,
    boxShadow = customTheme.boxShadow,
    hoverBoxShadow = customTheme.hoverBoxShadow;
  function getHoverBackgroundColor() {
    if (hoverBackgroundColor) {
      return hoverBackgroundColor;
    }
    return background === 'transparent' ? 'transparent' : (0, _color.darken)(background, 0.3);
  }
  function getCustomButtonHoverState() {
    return (0, _styledComponents.css)(["background:", ";color:", ";box-shadow:", ";", ";"], getHoverBackgroundColor(), hoverColor || color, hoverBoxShadow, getIconFillStyle(true));
  }

  // !important on color is because of foundation overrides
  return (0, _styledComponents.css)(["&,&:focus{color:", ";background:", ";font-family:", ";font-style:", ";font-weight:", ";font-size:", ";box-shadow:", ";", " ", " ", ";}&:hover{", "}&:focus-visible{", "}"], color, background, ((_customFont$fontFamil = _fonts.customFont[fontFamily]) === null || _customFont$fontFamil === void 0 ? void 0 : _customFont$fontFamil.font_family) || "".concat(fontFamily, ", 'ProximaNova'"), fontStyle, fontWeight, fontSize, boxShadow, border && "border: ".concat(border, ";"), borderRadius && "border-radius: ".concat(borderRadius, ";"), getIconFillStyle(false), getCustomButtonHoverState(), getCustomButtonHoverState());
}
var IconWrapper = exports.IconWrapper = _styledComponents["default"].span.withConfig({
  displayName: "HBButtonstyles__IconWrapper",
  componentId: "sc-jvf71c-0"
})(["", " ", " i{display:flex;}"], (0, _styledIs.match)('iconPosition', 'start')(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n        margin-right: ", ";\n    "])), function (props) {
  return iconSpacing[props.size];
}), (0, _styledIs.match)('iconPosition', 'end')(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n        order: 1;\n        margin-left: ", ";\n    "])), function (props) {
  return iconSpacing[props.size];
}));

// if textTransform is capitalize, capitalize only first letter, otherwise use textTransform
function getTextTransform(textTransform) {
  if (textTransform === 'capitalize') {
    return (0, _styledComponents.css)(["span{text-transform:lowercase;&::first-letter{text-transform:uppercase;}}"]);
  }
  return (0, _styledComponents.css)(["text-transform:", ";"], textTransform || 'uppercase');
}
var Button = exports.Button = _styledComponents["default"].button.withConfig({
  displayName: "HBButtonstyles__Button",
  componentId: "sc-jvf71c-1"
})(["position:relative;display:inline-flex;justify-content:center;align-items:center;user-select:none;border-radius:", ";border:none;letter-spacing:0;cursor:pointer;", ";white-space:nowrap;", ";", ";", " ", " margin:", ";&:hover{background:", ";}"], HBBUTTON_BORDER_RADIUS, function (props) {
  return getTextTransform(props.textTransform);
}, _animations.transition.apply(void 0, ['all'].concat((0, _toConsumableArray2["default"])(_variables.hoverEase))), function (props) {
  return buttonSizes[props.scope][props.size];
}, (0, _styledIs.isNot)('customTheme')(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n        ", "\n        ", "\n    "])), function (props) {
  return getButtonTheme(props.theme, props.$shouldUseIconDefaultFill);
}, function (props) {
  return getDisabledStyles(props.theme);
}), (0, _styledIs["default"])('fullWidth')(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n        width: 100%;\n    "]))), function (props) {
  return props.$margin;
}, function (props) {
  return props.theme.backgroundHover;
});
var CustomButton = exports.CustomButton = (0, _styledComponents["default"])(Button).withConfig({
  displayName: "HBButtonstyles__CustomButton",
  componentId: "sc-jvf71c-2"
})(["", " ", " text-transform:", ";"], function (props) {
  return getCustomTheme(props.customTheme);
}, function (props) {
  return getDisabledStyles('custom', props.customTheme);
}, function (props) {
  return props.textTransform || 'none';
});

// Override HBLoader styles
var Loader = exports.Loader = (0, _styledComponents["default"])(_HBLoader["default"]).withConfig({
  displayName: "HBButtonstyles__Loader",
  componentId: "sc-jvf71c-3"
})(["", ""], _mixins.absoluteCentered);
//# sourceMappingURL=HBButton.styles.js.map